/**
 * locale-by-customer.js
 *
 * Redirects logged-in customers to the Shopify market matching their assigned warehouse.
 * Customer data is read from window.ShopifyData (set in theme.liquid).
 *
 * Adding a new market:
 *   Add an entry to MARKETS below mapping warehouse code (the lowercase value of the
 *   customer/company metafield) to the URL prefix Shopify generates for that market.
 *   Use empty string for the primary market.
 */
(function () {
  'use strict';

  // ---- Config -----------------------------------------------------------------
  const MARKETS = {
    us: '',         // Primary market
    ca: '/en-ca',
    gb: '/en-gb',
    eu: '/en-eu',
  };

  const LOG = '[locale-by-customer]';

  // ---- Helpers ----------------------------------------------------------------
  function getData() {
    return window.ShopifyData || {};
  }

  function getCustomerWarehouse() {
    const wh = (getData().customerWarehouse || '').toLowerCase().trim();
    if (!wh) return null;
    if (!(wh in MARKETS)) {
      console.warn(`${LOG} unknown warehouse "${wh}", skipping redirect`);
      return null;
    }
    return wh;
  }

  function getCurrentMarketPrefix() {
    const match = window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/);
    return match ? match[0] : '';
  }

  function buildDestination(targetPrefix) {
    const { origin, pathname, search, hash } = window.location;
    const currentPrefix = getCurrentMarketPrefix();
    const cleanPath = currentPrefix ? pathname.slice(currentPrefix.length) : pathname;
    return origin + targetPrefix + (cleanPath || '/') + search + hash;
  }

  function submitLocalizationForm(returnTo) {
    const form = document.createElement('form');
    form.action = '/localization';
    form.method = 'POST';
    form.hidden = true;
    form.innerHTML = `
      <input name="form_type" value="localization">
      <input name="utf8" value="true">
      <input name="_method" value="PUT">
      <input name="return_to" value="${returnTo}">
    `;
    document.body.appendChild(form);
    form.submit();
  }

  // ---- Main -------------------------------------------------------------------
  function run() {
    try {
      const data = getData();

      // Guard: theme editor / preview
      if (data.designMode || (typeof Shopify !== 'undefined' && Shopify.designMode)) {
        console.log(`${LOG} skipped: design mode`);
        return;
      }

      // Guard: not logged in
      if (!data.customerId) {
        return;
      }

      const warehouse = getCustomerWarehouse();
      if (!warehouse) {
        console.log(`${LOG} no warehouse assigned, no redirect`);
        return;
      }

      const targetPrefix = MARKETS[warehouse];
      const currentPrefix = getCurrentMarketPrefix();

      if (currentPrefix === targetPrefix) {
        return; // Already on correct market
      }

      const destination = buildDestination(targetPrefix);
      console.log(`${LOG} redirecting ${currentPrefix || '/'} → ${destination}`);
      submitLocalizationForm(destination);
    } catch (err) {
      console.error(`${LOG} error:`, err);
       if (window.logCustomerError) {
    window.logCustomerError(err, { feature: 'locale_by_customer' });
  }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();